import React from 'react';
import { Outlet } from 'react-router-dom';
import useStyles from './styles';
import Sidebar from '../../helpers/Sidebar';
import NavBar from '../../helpers/Navbar';

const MainLayout = () => {
  const classes = useStyles();
  return (
    <div className={classes.layout_conainer}>
      <Sidebar />
      <div className={classes.main_layout}>
        <NavBar />
        <Outlet />
      </div>
    </div>
  );
};

export default MainLayout;
